import { Component } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../../../globals';
import { TakeawayServices } from '../../../../takeaway/services';
import { TranslateService } from '@ngx-translate/core';
import { TpvLoaderPage } from '../../../../tpv/tpv-loader/tpv-loader';
import { TPVServices } from '../../../../tpv/services';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the HomeDashboardLastLogsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-tk-no-paid',
  templateUrl: 'home-dashboard-tk-no-paid.html',
})
export class HomeDashboardTkNoPaidPage {

  list_takeaways: any = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public takeawayServices: TakeawayServices,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public tpvServices: TPVServices,) {
    this.list_takeaways = this.navParams.get('list_takeaways');
  }

  ionViewDidLoad() {
  }

  async openTicket(value) {
    if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
      this.globals.side_menu_active = 'tpv';
      this.tpvServices.menu_select_room = 'take_away';
      this.navCtrl.setRoot(TpvLoaderPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-billing/home-dashboard-tk-no-paid/home-dashboard-tk-no-paid.ts